export enum NeighborhoodGraphDirection {
    INCOMING = 'incoming',
    OUTGOING = 'outgoing',
    BOTH = 'both'
}
